import { getSiniestroDetailsApi, getLastSiniestroApi, getRentaPrestacionApi, getCertificadoPagoApi } from "../../../../../services/siniestrosApi";
import { openCloseToast } from "../../../../Global/actions";
import moment from "moment";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import trace from "../../../../../helpers/trace";
// import { getSiniestrosApi } from "../../../../../services/siniestrosApi"; GetSiniestroDocumentsApi, GetDocument

export const loading = (isLoading) => ({
  type: "LOADING_SINIESTROS",
  isLoading,
});

export const setSiniestros = (siniestros, filtros) => ({
  type: "SET_SINIESTROS",
  siniestros,
  filtros,
});

export const viewDetails = (view) => ({
  type: "VIEW_DETAILS",
  view,
});

export const setSelectedSiniestro = (siniestro) => ({
  type: "SET_SELECTED_SINIESTRO",
  siniestro,
});

export const setSiniestroDetails = (details) => ({
  type: "SET_SINIESTRO_DETAILS",
  details,
});

export const resetDetails = () => ({
  type: "RESET_DETAILS",
});


export const setLastSiniestro = (siniestro) => ({
  type: "SET_LAST_SINIESTRO",
  siniestro,
});

export const setDocumentSiniestro = (listDocuments) => ({
  type: "SET_DOCUMENT_SINIESTRO",
  listDocuments,
});

export const setshowNoDataAtencionesMedicas = (showNoDataAtencionesMedicas) => ({
  type: "SET_SHOW_DATA_ATENCIONES_MEDICAS_DETALLE",
  showNoDataAtencionesMedicas,
});

export const doGetDocumentRenta = (idPrestacion) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getRentaPrestacionApi(idPrestacion);
    if (request.status === 200) {
      const result = await request.blob();
      const objUrl = window.URL.createObjectURL(result);
      window.open(objUrl);
    } else if (request.status === 410) {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "La prestación no tiene documento",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    trace.error("doGetDocumentRenta", e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener el documento",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetcertificadoPago = (rut, idSiniestro) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getCertificadoPagoApi(rut, idSiniestro);
    if (request.status === 200) {
      const result = await request.blob();
      const objUrl = window.URL.createObjectURL(result);
      window.open(objUrl);
    } else if (request.status === 410) {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "El siniestro no tiene documento",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    trace.error("doGetcertificadoPago", e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener el documento",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};


export const doGetLastSiniestro = (rut) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getLastSiniestroApi(rut);
    if (request.status === 200) {
      const response = await request.json();
      let data = {};
      if (response.Success) { data = response.UltimoSiniestro; }

      dispatch(setLastSiniestro(data));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener el siniestro",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetDetails = (idSiniestro, selectedData) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let setSelected = { ...selectedData };
    dispatch(resetDetails());
    const request = await getSiniestroDetailsApi(idSiniestro);
    if (request.status === 200) {
      const response = await request.json();
      if (response.Success) {
        const siniestro = response.Siniestro;

        setSelected = Object.assign({}, selectedData, {
          LugarProximaConsulta: siniestro.EncabezadoDetalle.LugarProximaCitacion,
          ProximaConsulta: siniestro.EncabezadoDetalle.ProximaCitacion,
          FechaSiniestro: moment(selectedData.FechaSiniestro, "YYYY-MM-DD").isValid() === true ? moment(selectedData.FechaSiniestro, "YYYY-MM-DD").format("DD/MM/YYYY") : "S/D",
          FechaPresentacion: moment(selectedData.FechaPresentacion, "YYYY-MM-DD").isValid() === true ? moment(selectedData.FechaPresentacion, "YYYY-MM-DD").format("DD/MM/YYYY") : "S/D",
        });


        const pivotDetPrestEconomicas = siniestro.ListadoPrestacionesEconomicas.filter((y) => y.FechaUltimoPago === null).length > 0 ? siniestro.ListadoPrestacionesEconomicas.filter((y) => y.FechaUltimoPago === null) : [];
        const dataDetPrestEconomicas = siniestro.ListadoPrestacionesEconomicas.filter((d) => d.FechaUltimoPago !== null).sort((a, b) => formatDateForFilter(moment(b.FechaUltimoPago)) - formatDateForFilter(moment(a.FechaUltimoPago)));
        if (pivotDetPrestEconomicas.length > 0) { pivotDetPrestEconomicas.forEach((x) => dataDetPrestEconomicas.push(x)); }


        dispatch(setSiniestroDetails({
          atencionesMedicas: siniestro.ListadoAtencionesMedicas,
          periodosReposo: siniestro.ListadoReposo,
          evaluacionesIncapa: siniestro.ListadoEvaluacionIncapacidad,
          prestacionesEconomicas: dataDetPrestEconomicas,
        }));

        dispatch(setshowNoDataAtencionesMedicas(!(siniestro.ListadoAtencionesMedicas.length > 0)));
      }
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al obtener el detalle del siniestro",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
    dispatch(setSelectedSiniestro(setSelected));
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error al obtener el detalle del siniestro",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

